import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useRef,
  useContext,
} from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Box,
  Typography,
} from "@material-ui/core";

import { api, getOneAPI } from "../../../services";
import {
  SECONDARY_COLOR,
  ATALHO_AVANCAR,
  ATALHO_VOLTAR,
  SECONDARY_COLOR_OFFLINE,
} from "../../../utils";
import { AppContext } from "../../../app/context";
import { identificarBiometria } from "../../../services/biometria";
import InputBase from "@material-ui/core/InputBase";
import axios from "axios";

const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const ESC_ACTION = "Escape";
const CONSULTOR_PRECOS_ACTION = "F3";

function getTextoDedo(valorDedo) {
  switch (valorDedo) {
    case 1:
      return "Anelar direito";

    case 2:
      return "Anelar esquerdo";

    case 3:
      return "Indicador direito";

    case 4:
      return "Indicador esquerdo";

    case 5:
      return "Médio direito";

    case 6:
      return "Médio esquerdo";

    case 7:
      return "Mínimo direito";

    case 8:
      return "Mínimo esquerdo";

    case 9:
      return "Polegar direito";

    case 10:
      return "Polegar esquerdo";

    default:
      return "Desconhecido";
  }
}

function isAxiosNetworkError(error) {
  if (!axios.isAxiosError(error)) return false;

  // sem resposta do servidor
  if (error.request && !error.response) return true;

  // timeout
  if (error.code === "ECONNABORTED") return true;

  // network error
  if (error.message === "Network Error") return true;

  if (error.response?.status === 404) return true;

  if (error.response?.status >= 500) return true;

  return false;
}

const DialogoNota = forwardRef(
  (
    {
      handleSalvar,
      title,
      enqueueSnackbar,
      mensagemSucesso = "Item removido com sucesso!",
      openConsultorPrecos = () => {},
    },
    ref,
  ) => {
    const [open, setOpen] = useState(false);
    const [codigo, setCodigo] = useState(0);
    const [dados, setDados] = useState(null);
    const refControle = useRef(false);
    const [titulo, setTitulo] = useState("");
    const [conteudo, setConteudo] = useState("");
    const cancelRef = useRef({
      cancelado: false,
      cancelPause: null,
      cancelAxios: null,
    });

    const {
      app: { modoOffline },
    } = useContext(AppContext);

    const handleCloseDialog = () => {
      
      refControle.current = false;

      cancelRef.current.cancelado = true;

      if (cancelRef.current.cancelPause) {
        cancelRef.current.cancelPause();
      }

      if (cancelRef.current.cancelAxios) {
        cancelRef.current.cancelAxios.cancel("Operação cancelada pelo usuário");
      }

      setOpen(false);
    };

    function pause(ms) {
      return new Promise((resolve, reject) => {
        if(cancelRef.current) {
          if(cancelRef.current.cancelado) {
            return reject(new Error("CANCELADO"));
          }
        }
        
        const timeout = setTimeout(() => {
          resolve();
        }, ms);

        if(cancelRef.current) {
          cancelRef.current.cancelPause = () => {
            clearTimeout(timeout);
            reject(new Error("CANCELADO"));
          };
        }
        
      });
    }

    async function exibirConteudos(textos) {
      for(let i = 0; i < textos.length; i++) {
        setConteudo(textos[i].conteudo)
        if(textos[i].tempo) await pause(textos[i].tempo);
        if (!refControle.current) return null;
      }
    }

    async function identificarPessoa({ validarGerente, onFail, messagePadrao, cancelToken }) {
      while (refControle.current) {
        try {
          const { userId, status, message } = await identificarBiometria(cancelToken);
           if (!refControle.current) return null;

          if (!status) throw new Error(message);

          if (userId <= 0) throw new Error("Usuário não identificado");

          const id = Math.floor(userId / 100);
          const dedo = userId % 100;

          
          let user = null

          try {
            const response = await getOneAPI(`users`, id, [], { cancelToken });
            user = response.data;
             if (!refControle.current) return null;

            if (validarGerente && !user.is_responsavel) {
              throw new Error(`Primeira digital deve ser do gerente\n\n${user.username.toUpperCase()} não é um Gerente`);
            }
          } catch(e) {
            if(e.message === "Network Error") {
              throw 'Erro ao acessar o servidor'
            } else {
              throw e.message
            }
          }

          /* setConteudo(`${user.username.toUpperCase()}\nDedo Identificado (${getTextoDedo(dedo)})`);

          await pause(4000); */

          await exibirConteudos([
            {
              conteudo: `Sucesso: ${user.username.toUpperCase()}\n\nDedo Identificado (${getTextoDedo(dedo)})`,
              tempo: 2500
            }
          ])
          if (!refControle.current) return null;

          return {
            id,
            userId,
            nome: user.username,
          };
        } catch (e) {
          if (e.message === "CANCELADO" || axios.isCancel(e)) {
            return null;
          }
          

          if (!refControle.current) return null;

          if (isAxiosNetworkError(e)) {
            if (onFail) {
              setConteudo("Erro: Biometria indisponível, usando QRCode...");
              await pause(2000);
              if (!refControle.current) return null;

              onFail();
              return null;
            }
          }

          enqueueSnackbar(e?.message || e ? e.toString() : 'Erro Biometria', {
            variant: "warning",
          });

          /*  setConteudo(e?.message || "Erro biometria");
          await pause(4000);
          setConteudo("Tente novamente...");
          await pause(1000);
          setConteudo(messagePadrao); */

          await exibirConteudos([
            {
              conteudo: `Erro: ${e?.message || e ? e.toString() : 'Erro Biometria'}`,
              tempo: 2000
            },
            {
              conteudo: "Tente novamente...",
              tempo: 1000
            },
            {
              conteudo: messagePadrao,
            }
          ])
          if (!refControle.current) return null;
        }
      }

      return null;
    }

    async function identificar(onFail) {
      refControle.current = true;
      const source = axios.CancelToken.source();
      
      cancelRef.current = {
        cancelado: false,
        cancelPause: null,
        cancelAxios: source,
      };

      try {
        // =========================
        // GERENTE
        // =========================
        setTitulo("Autorização - Gerente");
        setConteudo("Gerente, insira sua digital...");

        const gerente = await identificarPessoa({
          validarGerente: true,
          onFail,
          messagePadrao: "Gerente, insira sua digital...",
          cancelToken: source.token,
        });

        if (!refControle.current) return null;
        if (!gerente) return;

        // =========================
        // SUCESSO
        // =========================
        if (refControle.current) {
          handleSalvar(gerente.id, dados, codigo);

          setOpen(false);

          enqueueSnackbar(mensagemSucesso, {
            variant: "success",
          });
        }
      } catch (e) {
        if (e.message === "CANCELADO" || axios.isCancel(e)) {
          return;
        }

        enqueueSnackbar(e?.message || "Erro", {
          variant: "error",
        });
      } finally {
        refControle.current = false;
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen(codigoNew = 0, dados = null, onFail = null) {
        setOpen(true);
        setCodigo(codigoNew);
        setDados(dados);
        identificar(onFail);
      },
    }));

    function handleKey(action, name) {
      switch (name) {
        case CANCELAR_VENDA_ACTION:
          handleCloseDialog();
          break;
        case ESC_ACTION:
          handleCloseDialog();
          break;
        case CONSULTOR_PRECOS_ACTION:
          openConsultorPrecos();
          break;
        default:
          break;
      }
    }

    const isErro = conteudo?.startsWith("Erro: ");
    const isSucesso = conteudo?.startsWith("Sucesso: ");
    let texto = conteudo

    let styleBox = {
      color: "#555",
      fontWeight: 'bold'
    };

    if (isErro) {
       texto = isErro ? conteudo.replace(/^Erro:\s*/, "") : conteudo;
      styleBox = {
        color: "#d32f2f",
        background: "#fdecea",
        border: "1px solid #f5c2c7"
      };
    }

    if (isSucesso) {
       texto = isSucesso ? conteudo.replace(/^Sucesso:\s*/, "") : conteudo;
      styleBox = {
        color: "#2e7d32",
        background: "#edf7ed",
        border: "1px solid #c8e6c9"
      };
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
          disableEscapeKeyDown
          onKeyDown={(e) => handleKey(e.keyCode, e.key)}
        >
          <DialogTitle
            id="form-dialog-title"
            style={{
              color: "white",
              backgroundColor: modoOffline
                ? SECONDARY_COLOR_OFFLINE
                : SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {title}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 320,
                padding: 20,
                textAlign: "center",
              }}
              //onKeyDown={(e) => handleKey(e.keyCode, e.key)}
              tabIndex={0}
            >
              {/* TITULO */}
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  marginBottom: 20,
                }}
              >
                {titulo}
              </div>

              {/* ICON */}
              <div
                style={{
                  fontSize: 64,
                  marginBottom: 20,
                }}
              >
                🔐
              </div>

              {/* CONTEUDO */}
            <div
                style={{
                  fontSize: 15,
                  marginBottom: 10,
                  whiteSpace: "pre-line",
                  padding: (isErro || isSucesso) ? "8px 12px" : 0,
                  borderRadius: 6,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  ...styleBox
                }}
              >
                {isErro && "❌"}
                {isSucesso && "✅"}
                {texto}
              </div>
            </div>
          </DialogContent>
          <DialogActions
            style={{ display: "flex", justifyContent: "center", padding: '15px' }}
          >
            <Button
              onClick={handleCloseDialog}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`Cancelar (${CANCELAR_VENDA_ACTION})`}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoNota;
